import { combineReducers } from "redux";
import facesPending from './facesPending'
import eKYCsPending from './eKYCsPending'

const listUsers = combineReducers({
    facesPending,
    eKYCsPending
})

export default listUsers